import { AppTooltip } from '@lmt/unicorn-shared/app/components/common/ui-kit/tooltip/AppTooltip';
import React, { FC } from 'react';
import CommentIcon from '@lmt/unicorn-shared/app/icons/comment.svg?react';
import { IconButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/IconButton';
import styles from './DocumentsList.module.scss';

interface Props {
  dateString: string;
  comment?: string;
}

export const DocumentGroupHeader: FC<Props> = (props) => {
  const { dateString, comment } = props;

  return (
    <div className={styles.documentGroupHeader}>
      <div className={styles.documentDate}>{dateString}</div>
      {comment && (
        <AppTooltip
          arrow
          placement={'bottom-end'}
          title={
            <div
              className={styles.comment}
              data-test-id="document-comment-text"
            >
              {comment}
            </div>
          }
        >
          <div data-test-id="document-comment-icon">
            <IconButton
              className={styles.commentButton}
              iconComponent={<CommentIcon className={styles.commentIcon} />}
            />
          </div>
        </AppTooltip>
      )}
    </div>
  );
};
